
import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { config } from '../config';
import { catchError } from 'rxjs/operators';
import { throwError, BehaviorSubject, Subject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class serviceURLService {
    authenticationToken: any;
    authorizedHeader: any;
    leavesLeftForUser: any;

    private messageSource = new BehaviorSubject<any>('');
    currentMessage = this.messageSource.asObservable();
    constructor(private httpClient: HttpClient) { }


    // {return this.http.post(environment.host + config.register, user);}

    getUserAuthentication() {
      
        const authToken = JSON.parse(localStorage.getItem('authToken'));
        this.authenticationToken = authToken ? authToken : '';
        this.authorizedHeader = new HttpHeaders().set('Authorization', `${this.authenticationToken}`);
       
    }

    submitMobileNumber(data) {
        let res = this.httpClient.put(environment.host + config.loginMobile + data.mobile, data, { headers: this.authorizedHeader }).pipe(catchError(this.error));
        return res;
    }

    getUserRole(data) {
        let res = this.httpClient.get(environment.pam2Url + config.getRole + data.mobile, data,).pipe(catchError(this.error));
        return res;
    }

    verifyOTP(otpMobile, otp) {
        let res = this.httpClient.get(environment.host + config.verifyOTP + otp.otp + '/' + otpMobile, { headers: this.authorizedHeader }).pipe(catchError(this.error));
        return res;
    }

    resendOTP(otpMobile, data) {
        let res = this.httpClient.get(environment.host + config.resendOTP + otpMobile, { headers: this.authorizedHeader }).pipe(catchError(this.error));
        return res;
    }

    registration(data) {
        let res = this.httpClient.post(environment.host + config.registerMobile, data);
        return res;
    }

    callSeniorCitizenCalc(data){
        let res = this.httpClient.post(environment.apiUrl + config.seniorCitizenCalc, data);
        return res;
    }

    callSeniorCitizenCareCalc(data){
        let res = this.httpClient.post(environment.platform + config.seniorCitizenCareCalc, data);
        return res;
    }

    SavingDataInPlatform(data){
        let res = this.httpClient.post(environment.platform + config.saveSeniorDataInPlatform, data);
        return res;
    }
    initiatePaymentForSeniorCitizen(data){
        let res = this.httpClient.post(environment.platform + config.paymentForSeniorCitizen, data);
        return res;
    }

    notification(data) {
        this.getUserAuthentication();
        let res = this.httpClient.get(environment.host + config.notification + data.updatedTime, { headers: this.authorizedHeader }).pipe(catchError(this.error));
        return res;
    }

    newNotification(data) {
        this.getUserAuthentication();
        let res = this.httpClient.get(environment.host + config.notification + data.updatedTime, { headers: this.authorizedHeader }).pipe(catchError(this.error));
        return res;
    }

    // getUserNotification(number) {
    //     this.getUserAuthentication();
    //     let res = this.httpClient.put(environment.host + config.getUserNotification + '?mobile=' + number, { headers: this.authorizedHeader }).pipe(catchError(this.error));
    //     return res;
    // }

    insurance(data) {
        this.getUserAuthentication();
        let res = this.httpClient.get(environment.host + config.insuranceDetails + data.updatedTime, { headers: this.authorizedHeader }).pipe(catchError(this.error));
        return res;
    }

    getPoliciesEcards(userId) {
        this.getUserAuthentication();
        let res = this.httpClient.get(environment.host + config.getPolicyCard + userId + "?isEcardDetail=false", { headers: this.authorizedHeader }).pipe(catchError(this.error));
        return res;
    }
    

    getCardDetails(cardId) {
        this.getUserAuthentication();
        let res = this.httpClient.get(environment.host + config.getPolicyCardDetails + cardId + "?isEcardDetail=true", { headers: this.authorizedHeader }).pipe(catchError(this.error));
        return res;
    }

    getPamPolicyDetails(policyNumber) {
        this.getUserAuthentication();
        let res = this.httpClient.get(environment.pam2Url + config.getPamPolicyDetails + "policyNumber=" + policyNumber , { headers: this.authorizedHeader }).pipe(catchError(this.error));
        return res;
    }

    getPolicyDetails(policyId, policyPlatform) {
        this.getUserAuthentication();
        let res = this.httpClient.get(environment.host + config.getPolicyNumberFilter + policyId + "/" + policyPlatform , { headers: this.authorizedHeader }).pipe(catchError(this.error));
        return res;
    }

    getClaimsInfo(policyNo) {
        this.getUserAuthentication();
        let res = this.httpClient.get(environment.msUrl + config.getClaimsInfo + 'policyNumber=' +  policyNo, { headers: this.authorizedHeader }).pipe(catchError(this.error));
        return res;
    }

    getMisChartData(policyNo) {
        this.getUserAuthentication();
        let res = this.httpClient.get(environment.msUrl + config.getMISChartData + 'policyNumber=' +  policyNo, { headers: this.authorizedHeader }).pipe(catchError(this.error));
        return res;
    }

    getEndorsmentData(clientId, insurerId, cdNameId ) {
        this.getUserAuthentication();
        let res = this.httpClient.get(environment.msUrl + config.getEndorsmentData + 'clientId='+ clientId + '&insurerId=' + insurerId + '&cdNamesId=' + cdNameId, { headers: this.authorizedHeader }).pipe(catchError(this.error));
        return res;
    }

    getAppDownloads(mobile, policyNumber) {
        this.getUserAuthentication();
        let res = this.httpClient.get(environment.host + config.getAppDownloadCount + mobile + '/' + policyNumber, { headers: this.authorizedHeader }).pipe(catchError(this.error));
        return res;
    }

    getInsurerLogo() {
        this.getUserAuthentication();
        let res = this.httpClient.get('https://securenow.in/admin/api/v1/insurer/getAll-insurerList?sort=DESC&size=300&page=0&search=').pipe(catchError(this.error));
        return res;
    }
    getTPA(policyNumber) {
        this.getUserAuthentication();
        let res = this.httpClient.get(environment.msUrl + config.getTPA+policyNumber, { headers: this.authorizedHeader }).pipe(catchError(this.error));
        return res;
    }

    getPolicybyPolicyID(policyId){
        this.getUserAuthentication();
        let res = this.httpClient.get(environment.msUrl + config.getPolicyByPolicyID+policyId, { headers: this.authorizedHeader }).pipe(catchError(this.error));
        return res;
    }

    getEclaims(policyNo){
   //  this.getUserAuthentication();
        let res = this.httpClient.get(environment.pam2Url + config.getEclaims+'startDate='+'&endDate='+'&input2='+'&dateType=dateCreated'+'&field='+'policyNumber'+'&input='+policyNo, { headers: this.authorizedHeader }).pipe(catchError(this.error));
        return res;
    }

    getCDledger(clientid,insurerId, cdNameId ){
        //  this.getUserAuthentication();
             let res = this.httpClient.get(environment.pam2Url + config.getCDledger+'clientId='+ clientid + '&insurerId=' + insurerId +'&cdNamesId='+cdNameId, { headers: this.authorizedHeader }).pipe(catchError(this.error));
             return res;
         }


    submitPolicyEditOrRenewRequest(policyEditdata) {
        this.getUserAuthentication();
        let res = this.httpClient.post(environment.msUrl + config.submitPolicyEditOrRenewRequest, policyEditdata, { headers: this.authorizedHeader }).pipe(catchError(this.error));
        return res;
    }

    getViewPolicies(userId) {
        this.getUserAuthentication();
        let res = this.httpClient.get(environment.host + config.getPolicies + userId + "/viewPolicy", { headers: this.authorizedHeader }).pipe(catchError(this.error));
        return res;
    }
    checkPolicies(userId,mobile) {
        this.getUserAuthentication();
        let res = this.httpClient.get(environment.host + config.checkPoliciesPresent + userId + '/' + mobile , { headers: this.authorizedHeader }).pipe(catchError(this.error));
        return res;
    }
    
    checkIn(data, userID) {
        this.getUserAuthentication();
        let res = this.httpClient.post(environment.host + config.checkIn + userID, data, { headers: this.authorizedHeader }).pipe(catchError(this.error));
        return res;
    }
    checkOut(data, userID) {
        this.getUserAuthentication();
        let res = this.httpClient.post(environment.host + config.checkOut + userID, data, { headers: this.authorizedHeader }).pipe(catchError(this.error));
        return res;
    }

    getLeaveCount(data, userID) {
        this.getUserAuthentication();
        let res = this.httpClient.get(environment.host + config.leaveCount + userID + '/' + data.updatedTime, { headers: this.authorizedHeader }).pipe(catchError(this.error));
        return res;
    }

    getUpdatedLeaveCount(data, userID) {
        this.getUserAuthentication();
        let res = this.httpClient.get(environment.host + config.UpdatedleaveCount + userID + '/' + data.updatedTime, { headers: this.authorizedHeader }).pipe(catchError(this.error));
        return res;
    }
    getTeamCount(data, userID) {
        this.getUserAuthentication();
        let res = this.httpClient.get(environment.host + config.leaveCount + userID + '/' + data.updatedTime, { headers: this.authorizedHeader }).pipe(catchError(this.error));
        return res;
    }
    getInOutCount(userID) {
        this.getUserAuthentication();
        let res = this.httpClient.get(environment.host + config.InOutCount + userID + '/count?checkIn=true&checkOut=true&team=true&leave=true', { headers: this.authorizedHeader }).pipe(catchError(this.error));
        return res;
    }

    applyLeave(data, userID) {
        this.getUserAuthentication();
        let res = this.httpClient.post(environment.host + config.applyLeaves + userID, data, { headers: this.authorizedHeader }).pipe(catchError(this.error));
        return res;
    }

    getScheduledLeaveCount(data, userID) {
        this.getUserAuthentication();
        let res = this.httpClient.post(environment.host + config.leaveCount + userID + '/' + data.updatedTime, data, { headers: this.authorizedHeader }).pipe(catchError(this.error));
        return res;
    }

    cancelLeaveRequest(data, userID) {
        this.getUserAuthentication();
        let res = this.httpClient.post(environment.host + config.cancelLeaves + userID, data, { headers: this.authorizedHeader }).pipe(catchError(this.error));
        return res;
    }

  

    getTeam(data, userID) {
        this.getUserAuthentication();
        let res = this.httpClient.get(environment.host + config.getTeamList + userID + '/' + data.updatedTime, { headers: this.authorizedHeader }).pipe(catchError(this.error));
        return res;
    }

    getUpdatedTeam(data, userID) {
        this.getUserAuthentication();
        let res = this.httpClient.get(environment.host + config.UpdatedgetTeamList + userID + '/' + data.updatedTime, { headers: this.authorizedHeader }).pipe(catchError(this.error));
        return res;
    }

    addInsurance(data) {
        this.getUserAuthentication();
        let res = this.httpClient.post(environment.host + config.addInsurance, data, { headers: this.authorizedHeader }).pipe(catchError(this.error));
        return res;
    }

    addPolicies(data, userId) {
        this.getUserAuthentication();
        let res = this.httpClient.post(environment.host + config.addPolicies + userId, data, { headers: this.authorizedHeader }).pipe(catchError(this.error));
        return res;
    }

    addAttachment(data, policyId) {
        let authorizedHeader = new HttpHeaders();
        authorizedHeader.append('Content-Type', 'multipart/form-data');
        authorizedHeader.append('Accept', 'application/json');
        const authToken = JSON.parse(localStorage.getItem('authToken'));
        this.authenticationToken = authToken ? authToken : '';
        authorizedHeader = authorizedHeader.set('Authorization', `${this.authenticationToken}`);

        // this.getUserAuthentication();
        let res = this.httpClient.post(environment.host + config.uploadPolicyAttachment + policyId, data, { headers: authorizedHeader }).pipe(catchError(this.error));
        return res;
    }

    updateInsurance(data) {
        this.getUserAuthentication();
        let res = this.httpClient.put(environment.host + config.addInsurance, data, { headers: this.authorizedHeader }).pipe(catchError(this.error));
        return res;
    }

    checkInSupervisor(data, userID) {
        this.getUserAuthentication();
        let res = this.httpClient.post(environment.host + config.checkInSupervisor + userID + '/IN', data, { headers: this.authorizedHeader }).pipe(catchError(this.error));
        return res;
    }

    checkOutSupervisor(data, userID) {
        this.getUserAuthentication();
        let res = this.httpClient.post(environment.host + config.checkInSupervisor + userID + '/OUT', data, { headers: this.authorizedHeader }).pipe(catchError(this.error));
        return res;
    }

    absentApprovalBySupervisor(data, userID) {
        this.getUserAuthentication();
        let res = this.httpClient.post(environment.host + config.checkInSupervisor + userID + '/ABSENT', data, { headers: this.authorizedHeader }).pipe(catchError(this.error));
        return res;
    }
    
    LeaveApproveSupervisor(data, userID) {
        this.getUserAuthentication();
        let res = this.httpClient.post(environment.host + config.supervisorLeaveApprove + userID, data, { headers: this.authorizedHeader }).pipe(catchError(this.error));
        return res;
    }

    getProfileDetails(userID) {
        this.getUserAuthentication();
        let res = this.httpClient.get(environment.host + config.getUserProfile + userID, { headers: this.authorizedHeader }).pipe(catchError(this.error));
        return res;
    }

    setProfileDetails(data) {
        let res = this.httpClient.put(environment.host + config.getSetProfile, data, { headers: this.authorizedHeader }).pipe(catchError(this.error));
        return res;
    }

    addFamilyMembers(userID, data) {
        this.getUserAuthentication();
        let res = this.httpClient.post(environment.host + config.addFamily + userID, data, { headers: this.authorizedHeader }).pipe(catchError(this.error));
        return res;
    }

    deleteNotification(data) {
        this.getUserAuthentication();
        let res = this.httpClient.post(environment.host + config.deleteNotification, data, { headers: this.authorizedHeader }).pipe(catchError(this.error));
        return res;
    }

    viewNotification(data) {
        let res = this.httpClient.put(environment.host + config.viewNotification, data, { headers: this.authorizedHeader }).pipe(catchError(this.error));
        return res;
    }

    createProspect(data) {
        this.getUserAuthentication();
        let res = this.httpClient.post(environment.msUrl + config.createProspect, data, { headers: this.authorizedHeader }).pipe(catchError(this.error));
        return res;
    }

    getProductUrl(formData) {
        this.getUserAuthentication();
        let res = this.httpClient.post(environment.pam2Url + config.getProductUrl, formData, { headers: this.authorizedHeader }).pipe(catchError(this.error));
        return res;
    }

    saveFHIProspect(data) {
        this.getUserAuthentication();
        let res = this.httpClient.post(environment.msUrl + config.saveFHIProspect, data, { headers: this.authorizedHeader }).pipe(catchError(this.error));
        return res;
    }

    updateWellnessRegistration(data) {
        this.getUserAuthentication();
        let res = this.httpClient.post(environment.host + config.updateWellnessRegistration, data, { headers: this.authorizedHeader }).pipe(catchError(this.error));
        return res;
    }

    goPersonalAccident(data) {
        this.getUserAuthentication();
        let res = this.httpClient.post(environment.host + config.getPersonalAccident, data, { headers: this.authorizedHeader }).pipe(catchError(this.error));
        return res;
    }

    getSumInsuredList() {
        //this.getUserAuthentication();
        let res = this.httpClient.get(environment.pam2Url + config.getSumInsuredList, { headers: this.authorizedHeader }).pipe(catchError(this.error));
        return res;
    }

    getPAQuoteDetails(data) {
        let res = this.httpClient.post(environment.pam2Url + config.getPAQuoteDetails, data, { headers: this.authorizedHeader }).pipe(catchError(this.error));
        return res;
    }

    downloadPdfPA(quoteId) {
        let res = this.httpClient.get(environment.pam2Url + config.PAdownloadPDF + '?id=' + quoteId, { headers: this.authorizedHeader }).pipe(catchError(this.error));
        return res;
    }

    sendPDFEmailPA(quoteId) {
        let res = this.httpClient.get(environment.pam2Url + config.PAsendPDFEmail + '?id=' + quoteId, { headers: this.authorizedHeader }).pipe(catchError(this.error));
        return res;
    }

    /*Motor Insurance start*/
    getManufacturerList() {
        let res = this.httpClient.get(environment.msUrl + config.getManufacturerListMS, { headers: this.authorizedHeader }).pipe(catchError(this.error));
        return res;
    }
    getVehileModelList(code) {
        let res = this.httpClient.get(environment.msUrl + config.getVehicleListMS + '?manufacturerName=' + code, { headers: this.authorizedHeader }).pipe(catchError(this.error));
        return res;
    }
    getStateList() {
        let res = this.httpClient.get(environment.msUrl + config.getStateListMS, { headers: this.authorizedHeader }).pipe(catchError(this.error));
        return res;
    }
    getAllStateList() {
        let res = this.httpClient.get(environment.msUrl + config.getStateListALL, { headers: this.authorizedHeader }).pipe(catchError(this.error));
        return res;
    }
    getAllCityList(code) {
        let res = this.httpClient.get(environment.msUrl + config.getCityListALL + '/' + code, { headers: this.authorizedHeader }).pipe(catchError(this.error));
        return res;
    }
    getRtoCityList(code) {
        let res = this.httpClient.get(environment.msUrl + config.getCityListMS + '?stateCode=' + code, { headers: this.authorizedHeader }).pipe(catchError(this.error));
        return res;
    }
    getRtoAgency() {
        let res = this.httpClient.get(environment.msUrl + config.getRtoAgency, { headers: this.authorizedHeader }).pipe(catchError(this.error));
        return res;
    }
    getGoDigitVehicleCode(data) {
        let res = this.httpClient.post(environment.apiUrl + config.motorGoDigitVehicleCode, data, { headers: this.authorizedHeader }).pipe(catchError(this.error));
        return res;
    }
    motorComparePremium(data, insurer) {
        this.getUserAuthentication();
        let res = this.httpClient.post(environment.msUrl + config.motorComparePremium + "?mode=mobile" + "&insurer=" + insurer, data, { headers: this.authorizedHeader }).pipe(catchError(this.error));
        return res;
    }
    motorFetchQuote(data, insurer) {
        this.getUserAuthentication();
        let res = this.httpClient.post(environment.msUrl + config.motorFetchQuoteDetails + "?insurer=" + insurer, data, { headers: this.authorizedHeader }).pipe(catchError(this.error));
        return res;
    }
    saveMotorQuoteDetails(data) {
        this.getUserAuthentication();
        let res = this.httpClient.post(environment.msUrl + config.saveMotorQuoteDetails, data, { headers: this.authorizedHeader }).pipe(catchError(this.error));
        return res;
    }
    saveMotorProposalHdfc(data) {
        this.getUserAuthentication();
        let res = this.httpClient.post(environment.msUrl + config.saveMotorProposalHdfc, data, { headers: this.authorizedHeader }).pipe(catchError(this.error));
        return res;
    }
    saveMotorProposalGodigit(data) {
        this.getUserAuthentication();
        let res = this.httpClient.post(environment.msUrl + config.saveMotorProposalGodigit, data, { headers: this.authorizedHeader }).pipe(catchError(this.error));
        return res;
    }
    getMotorHdfcOtp(data) {
        let res = this.httpClient.get(environment.msUrl + config.getMotorHdfcOtp + "?mobile=" + data, { headers: this.authorizedHeader }).pipe(catchError(this.error));
        return res;
    }
    motorCalculatePremiumHdfc(data) {
        this.getUserAuthentication();
        let res = this.httpClient.post(environment.msUrl + config.motorCalculatePremiumHdfc, data, { headers: this.authorizedHeader }).pipe(catchError(this.error));
        return res;
    }
    motorCalculatePremiumGoDigit(data) {
        this.getUserAuthentication();
        let res = this.httpClient.post(environment.msUrl + config.motorCalculatePremiumGoDigit, data, { headers: this.authorizedHeader }).pipe(catchError(this.error));
        return res;
    }
    getHdfcProposal(data) {
        this.getUserAuthentication();
        let res = this.httpClient.post(environment.msUrl + config.motorGethdfcProposal, data, { headers: this.authorizedHeader }).pipe(catchError(this.error));
        return res;
    }
    motorGoDigitGeneratePolicy(data) {
        this.getUserAuthentication();
        let res = this.httpClient.post(environment.msUrl + config.motorGoDigitGeneratePolicy, data, { headers: this.authorizedHeader }).pipe(catchError(this.error));
        return res;
    }
    motorInitiatePayment(data) {
        this.getUserAuthentication();
        let res = this.httpClient.post(environment.msUrl + config.motorInitiatePayment, data, { headers: this.authorizedHeader }).pipe(catchError(this.error));
        return res;
    }

    getGodigitPaymentAck(data, txnId, transactionNo) {
        this.getUserAuthentication();
        let res = this.httpClient.post(environment.msUrl + config.motorGoDigitPaymentAck + '?txnId=' + txnId + '&transactionNumber=' + transactionNo, data, { headers: this.authorizedHeader }).pipe(catchError(this.error));
        return res;
    }
    getGodigitPincodeSortedA() {
        this.getUserAuthentication();
        let res = this.httpClient.get(environment.msUrl + config.getGodigitPincodeSortedA, { headers: this.authorizedHeader }).pipe(catchError(this.error));
        return res;
    }
    getGodigitPincodeSortedB() {
        this.getUserAuthentication();
        let res = this.httpClient.get(environment.msUrl + config.getGodigitPincodeSortedB, { headers: this.authorizedHeader }).pipe(catchError(this.error));
        return res;
    }
    getHdfcPincodeSorted() {
        this.getUserAuthentication();
        let res = this.httpClient.get(environment.apiUrl + config.getHdfcPincodeSorted, { headers: this.authorizedHeader }).pipe(catchError(this.error));
        return res;
    }
    getGodigitPreviousInsurer() {
        this.getUserAuthentication();
        let res = this.httpClient.get(environment.msUrl + config.goDigitInsurerCode, { headers: this.authorizedHeader }).pipe(catchError(this.error));
        return res;
    }
    /*Motor Insurance end*/

    getInsuropediaResult(searchContent) {
        // localStorage.getItem()
        let res = this.httpClient.get(environment.host + config.getInsuropediaResult + '/1/' + searchContent, { headers: this.authorizedHeader }).pipe(catchError(this.error));
        //this.messageSource.next(res);
        return res;
    }
    changeMessage(message) {
        this.messageSource.next(message);
        return message;
    }
    getProductId() {
        let res = this.httpClient.get(environment.host + config.getProductId, { headers: this.authorizedHeader }).pipe(catchError(this.error));
        return res;
    }
    getNomineeList() {
        //this.getUserAuthentication();
        let res = this.httpClient.get(environment.pam2Url + config.getNomineeList, { headers: this.authorizedHeader }).pipe(catchError(this.error));
        return res;
    }
    getOccupationList() {
        //this.getUserAuthentication();
        let res = this.httpClient.get(environment.pam2Url + config.getOccupationList, { headers: this.authorizedHeader }).pipe(catchError(this.error));
        return res;
    }
    getCityStateList(data) {
        //this.getUserAuthentication();
        let res = this.httpClient.post(environment.pam2Url + config.getCityStateList, data, { headers: this.authorizedHeader }).pipe(catchError(this.error));
        return res;
    }
    getProposalService(data) {
        //this.getUserAuthentication();
        let res = this.httpClient.post(environment.pam2Url + config.getProposalService, data, { headers: this.authorizedHeader }).pipe(catchError(this.error));
        return res;
    }
    getTransactionURL(data) {
        let res = this.httpClient.post(environment.pam2Url + config.getTransactionURL, data, { headers: this.authorizedHeader }).pipe(catchError(this.error));
        return res;
    }

    // for refer page

    referFriend(referData) {
        this.getUserAuthentication();
        let res = this.httpClient.post(environment.host + config.referFriendURL, referData, { headers: this.authorizedHeader }).pipe(catchError(this.error));
        return res;
    }

    getCities() {
        this.getUserAuthentication();
        let res = this.httpClient.get(environment.pam2Url + config.getCities, { headers: this.authorizedHeader }).pipe(catchError(this.error));
        return res;
    }

    getTransactionResponsonsePA(transactionId) {
        let res = this.httpClient.get(environment.pam2Url + config.getTransactionResponsePA + '?secureNowTxnRefNo=' + transactionId, { headers: this.authorizedHeader }).pipe(catchError(this.error));
        return res;
    }

    sentEmail(data) {
        this.getUserAuthentication();
        let res = this.httpClient.post(environment.host + config.sentEmail, data, { headers: this.authorizedHeader }).pipe(catchError(this.error));
        return res;
    }

    getIntimateGroupPolicyData() {
        this.getUserAuthentication();
        let res = this.httpClient.get(environment.host + config.getIntimateGroupPolicyData, { headers: this.authorizedHeader }).pipe(catchError(this.error));
        return res;
    }

    getIntimateIndividualPolicyData(mobileNo) {
        let res = this.httpClient.get(environment.apiUrl + config.getIntimateIndividualPolicyData + '?contactNo=' + mobileNo, { headers: this.authorizedHeader }).pipe(catchError(this.error));
        return res;
    }

    getHospitals(hospitalName, insurerOrTpa, pincode, policyNumber) {
        let res = this.httpClient.get(environment.msUrl + config.getHospitals + "?hospitalName=" + hospitalName + "&insurerOrTpa=" + insurerOrTpa + "&pincode=" + pincode + "&policyNumber=" + policyNumber, { headers: this.authorizedHeader }).pipe(catchError(this.error));
        return res;
    }
    getStateListCare() {
        let res = this.httpClient.get(environment.msUrl + config.getStateListCare, { headers: this.authorizedHeader }).pipe(catchError(this.error));
        return res;
    }

    getCityListCare(stateCode){
        let res = this.httpClient.get(environment.msUrl + config.getCityListCare+"?stateId="+stateCode, { headers: this.authorizedHeader }).pipe(catchError(this.error));
        return res;
    }

    getHospitalNameListCare(stateCode, CityCode){
        let res = this.httpClient.get(environment.msUrl + config.getHospitalListCare+"?stateId="+stateCode+"&cityId="+CityCode, { headers: this.authorizedHeader }).pipe(catchError(this.error));
        return res;  
    }

    // submitClaimIntimate(data) {
    //     let res = this.httpClient.post(environment.msUrl + config.submitClaimIntimateMS, data, { headers: this.authorizedHeader }).pipe(catchError(this.error));
    //     return res;
    // }

    submitClaimIntimate(data) {
        let res = this.httpClient.post(environment.host + config.submitClaimIntimateMSUsingNotify, data, { headers: this.authorizedHeader }).pipe(catchError(this.error));
        return res;
    }

    // getClaimDataByMobile(mobileNo) {
    //     let res = this.httpClient.get(environment.pam2Url + config.savedClaimData + mobileNo).pipe(catchError(this.error));
    //     return res;
    // }

    getClaimDataByMobile(mobileNo) {
        let res = this.httpClient.get(environment.host + config.savedClaimDataUsingNotify + mobileNo, { headers: this.authorizedHeader }).pipe(catchError(this.error));
        return res;
    }


    // getClaimHistoryByIntimation(intimation) {
    //     let res = this.httpClient.get(environment.pam2Url + config.getClaimsHistory + intimation).pipe(catchError(this.error));
    //     return res;
    // }

    // getClaimInfoByIntimationNo(intimatinNo) {
    //     let res = this.httpClient.get(environment.pam2Url + config.claimInfo + intimatinNo).pipe(catchError(this.error));
    //     return res;
    // }

    getClaimInfoByIntimationNo(intimatinNo) {
        let res = this.httpClient.get(environment.host + config.claimInfoUsingNotify + intimatinNo, { headers: this.authorizedHeader }).pipe(catchError(this.error));
        return res;
    }

    // sendMailOnClaimSubmit(intimatinNo, insurerId, tpaId){
    //    this.getUserAuthentication();
    //     let res = this.httpClient.post(environment.msUrl + config.sendMailOnClaim + "?intimationNumber=" + intimatinNo  + "&tpaId=" + tpaId + "&insurerId=" + insurerId,{ headers: this.authorizedHeader } ).pipe(catchError(this.error));
    //     return res;
    // }
  
    sendMailOnClaimSubmit(intimatinNo, insurerId, tpaId) {
        let queryParams ="?intimationNumber=" + intimatinNo + "&tpaId=" + tpaId + "&insurerId=" + insurerId;
        let res = this.httpClient.post(environment.host + config.sendMailOnClaimUsingNotify+queryParams,{} , { headers: this.authorizedHeader }).pipe(catchError(this.error));
        return res;
    }

    uploadDocument(formData, eclaimsId) {
        let authorizedHeader = new HttpHeaders();
        authorizedHeader.append('Content-Type', 'multipart/form-data');
        // authorizedHeader.append('Accept', 'application/json');
        let res = this.httpClient.post(environment.pam2Url + config.uploadDoc + '?eclaimsId=' + eclaimsId, formData, { headers: this.authorizedHeader }).pipe(catchError(this.error));
        return res;
    }

    // getDocumentsByIntimationNo(intimatinNo) {
    //     let res = this.httpClient.get(environment.pam2Url + config.getDoc + intimatinNo).pipe(catchError(this.error));
    //     return res;
    // }

    getDocumentsByIntimationNo(intimatinNo) {
        let res = this.httpClient.get(environment.host + config.getDocUsingNotify + intimatinNo, { headers: this.authorizedHeader }).pipe(catchError(this.error));
        return res;
    }


    deleteDocumentByClaimsDocId(id) {
        console.log(environment.msUrl + config.deleteDoc + id);
        let res = this.httpClient.delete(environment.pam2Url + config.deleteDoc + id).pipe(catchError(this.error));
        return res;
    }

    // getIntimationNumbersBy(mobileNo) {
    //     let res = this.httpClient.get(environment.pam2Url + config.intimationNumberList + mobileNo).pipe(catchError(this.error));
    //     return res;
    // }

    getIntimationNumbersBy(mobileNo) {
        let res = this.httpClient.get(environment.pam2Url + config.intimationNumberListUsingNotify + mobileNo, { headers: this.authorizedHeader }).pipe(catchError(this.error));
        return res;
    }

    getIntimationNumbersUsingNotify(mobileNo) {
        let res = this.httpClient.get(environment.host + config.intimationNumberListUsingNotify + mobileNo, { headers: this.authorizedHeader }).pipe(catchError(this.error));
        return res;
    }

    launchOffer(launchData, userId) {
        let res = this.httpClient.post(environment.host + config.submitLaunchOffer + userId, launchData, { headers: this.authorizedHeader }).pipe(catchError(this.error));
        return res;
    }

    getLaunchOfferData(userId) {
        let res = this.httpClient.get(environment.host + config.getLaunchOfferData + userId, { headers: this.authorizedHeader }).pipe(catchError(this.error));
        return res;
    }
    //For Referral Article
    getArticlesData(userId) {
        let res = this.httpClient.get(environment.host + config.getArticlesData + userId, { headers: this.authorizedHeader }).pipe(catchError(this.error));
        return res;
    }

    sendLikeCount(data, userId) {
        this.getUserAuthentication();
        let res = this.httpClient.post(environment.host + config.sendLikeArticle + userId, data, { headers: this.authorizedHeader }).pipe(catchError(this.error));
        return res;
    }

    getLikeCount(userId, articleId) {
        this.getUserAuthentication();
        let res = this.httpClient.post(environment.host + config.getLikeCount + userId + '/' + articleId, { headers: this.authorizedHeader }).pipe(catchError(this.error));
        return res;
    }

    saveReferral(userId, data) {
        this.getUserAuthentication();
        let res = this.httpClient.post(environment.host + config.saveReferral + userId, data, { headers: this.authorizedHeader }).pipe(catchError(this.error));
        return res;
    }

    getDoctorPIquoteDetails(data) {
        this.getUserAuthentication();
        let res = this.httpClient.post(environment.apiUrl + config.getDoctorPIquoteDetails, data, { headers: this.authorizedHeader }).pipe(catchError(this.error));
        return res;
    }

    saveDoctorProfessionIndemnityData(data) {
        this.getUserAuthentication();
        let res = this.httpClient.post(environment.msUrl + config.saveIndemnityUnitedIndiaData, data, { headers: this.authorizedHeader }).pipe(catchError(this.error));
        return res;
    }

    sendMailDocPIPDF(quoteId) {
        this.getUserAuthentication();
        let res = this.httpClient.get(environment.msUrl + config.sendMailDocPIPDF + quoteId, { headers: this.authorizedHeader }).pipe(catchError(this.error));
        return res;
    }


    initiatePayment(data) {
        this.getUserAuthentication();
        let res = this.httpClient.post(environment.msUrl + config.initiatePayment, data, { headers: this.authorizedHeader }).pipe(catchError(this.error));
        return res;
    }

    paymentStatus(data) {
        this.getUserAuthentication();
        let res = this.httpClient.post(environment.msUrl + config.paymentStatus, data, { headers: this.authorizedHeader }).pipe(catchError(this.error));
        return res;
    }

    saveDoctorProfessionalProposal(data) {
        this.getUserAuthentication();
        let res = this.httpClient.post(environment.msUrl + config.saveSubmitDoctorProfessionalProposal, data, { headers: this.authorizedHeader }).pipe(catchError(this.error));
        return res;
    }
    downloadGoDigitResponsePdf(applicationId) {
        let res = this.httpClient.get(environment.msUrl + config.motorGoDigitDownloadSuccessPdf + '?applicationId=' + applicationId, { headers: this.authorizedHeader }).pipe(catchError(this.error));
        return res;
    }

    createProspectForCovid(data) {
        this.getUserAuthentication();
        let res = this.httpClient.post(environment.pam2Url + config.creatProspectForCovid, data, { headers: this.authorizedHeader }).pipe(catchError(this.error));
        return res;
    }

    createProspectForDCA(data) {
        this.getUserAuthentication();
        let res = this.httpClient.post(environment.pam2Url + config.createProspect, data, { headers: this.authorizedHeader }).pipe(catchError(this.error));
        return res;
    }

    createProspectForHomeLoan(data) {
        this.getUserAuthentication();
        let res = this.httpClient.post(environment.pam2Url + config.creatProspectForHomeLoan, data, { headers: this.authorizedHeader }).pipe(catchError(this.error));
        return res;
    }

    createProspectForMaxLife(data) {
        this.getUserAuthentication();
        let res = this.httpClient.get(environment.pam2Url + config.creatProspectForMaxLife+"?prospectId="+data , { headers: this.authorizedHeader }).pipe(catchError(this.error));
        return res;
    }

    createprospectforTopupHealth(data) {
        this.getUserAuthentication();
        let res = this.httpClient.post(environment.pam2Url + config.createprospectforTopupHealth, data, { headers: this.authorizedHeader }).pipe(catchError(this.error));
        return res;
    }

    sendCovidPDF(quoteIdForCovid) {
        this.getUserAuthentication();
        let res = this.httpClient.post(environment.pam2Url + config.sendCovidPDF + quoteIdForCovid, { headers: this.authorizedHeader }).pipe(catchError(this.error));
        return res;
    }

    saveQuoteDataCovid(prospectId) {
        this.getUserAuthentication();
        let res = this.httpClient.post(environment.pam2Url + config.saveQuoteDataCovid + prospectId, { headers: this.authorizedHeader }).pipe(catchError(this.error));
        return res;
    }

    saveProposalDataForCovid(data) {
        this.getUserAuthentication();
        let res = this.httpClient.post(environment.pam2Url + config.saveProposalForCovid, data, { headers: this.authorizedHeader }).pipe(catchError(this.error));
        return res;
    }

    initiatePaymentForCovid(data) {
        this.getUserAuthentication();
        let res = this.httpClient.post(environment.pam2Url + config.initiatePaymentForCovid, data, { headers: this.authorizedHeader }).pipe(catchError(this.error));
        return res;
    }

    // family health insuranc
    submitAgeDetail(familyData) {
        this.getUserAuthentication();
        let res = this.httpClient.post(environment.pam2Url + config.submitFamilyHealthAge + '?sumInsured=' + familyData.sumInsured + '&age=' + familyData.age + '&familyMembers=' + familyData.familyMembers, { headers: this.authorizedHeader }).pipe(catchError(this.error));
        return res;
    }

    getFamilyHeathQuote(quoteData) {
        this.getUserAuthentication();
        let res = this.httpClient.post(environment.apiUrl + config.familyHealthQuote, quoteData, { headers: this.authorizedHeader }).pipe(catchError(this.error));
        return res;
    }

    getCareFamilyHeathQuote(quoteData){
        this.getUserAuthentication();
        let res = this.httpClient.post(environment.apiUrl + config.careFamilyHealthQuote, quoteData, { headers: this.authorizedHeader }).pipe(catchError(this.error));
        return res;
    }

    createHealthProspect(prospectData) {
        this.getUserAuthentication();
        let res = this.httpClient.post(environment.pam2Url + config.healthCreateProspect, prospectData, { headers: this.authorizedHeader }).pipe(catchError(this.error));
        return res;
    }

    HealthDetailsSave(saveHealthData) {
        this.getUserAuthentication();
        let res = this.httpClient.post(environment.pam2Url + config.saveHeathDetails, saveHealthData, { headers: this.authorizedHeader }).pipe(catchError(this.error));
        return res;
    }

    getCityStateForRoyalSundaram(data) {
        this.getUserAuthentication();
        let res = this.httpClient.get(environment.pam2Url + config.getCityStateForRoyalSundaram + '?type=' + data.type + '&state=' + data.state, { headers: this.authorizedHeader }).pipe(catchError(this.error));
        return res;
    }

    getPremiumForRoyalSundram(premiumData) {
        this.getUserAuthentication();
        let res = this.httpClient.post(environment.pam2Url + config.getFamilyHealthPremiumForRoayalSundram, premiumData, { headers: this.authorizedHeader }).pipe(catchError(this.error));
        return res;
    }

    familyHealthSaveProspect(saveData) {
        this.getUserAuthentication();
        let res = this.httpClient.post(environment.pam2Url + config.FamilyHealthSaveProspect, saveData, { headers: this.authorizedHeader }).pipe(catchError(this.error));
        return res;
    }

    careFamilyHealthSaveProspect(saveData) {
        this.getUserAuthentication();
        let res = this.httpClient.post(environment.pam2Url + config.careFamilyHealthSaveProspect, saveData, { headers: this.authorizedHeader }).pipe(catchError(this.error));
        return res;
    }

    familyHealthCalculatePremiumRoyalSundram(data) {
        this.getUserAuthentication();
        let res = this.httpClient.post(environment.pam2Url + config.familyHealthCalculatePremium, data, { headers: this.authorizedHeader }).pipe(catchError(this.error));
        return res;
    }

    getNotificationCount() {
        this.getUserAuthentication();
        let res = this.httpClient.get(environment.host + config.getNotificationCount, { headers: this.authorizedHeader }).pipe(catchError(this.error));
        return res;
    }
    familyHealthFinalPremiumRoyalSundram(data) {
        this.getUserAuthentication();
        let res = this.httpClient.post(environment.pam2Url + config.familyHealthfinalPremiumRoyalSundram, data, { headers: this.authorizedHeader }).pipe(catchError(this.error));
        return res;
    }
    proceedtoPayRoyalSundaram(data) {
        this.getUserAuthentication();
        let res = this.httpClient.post(environment.pam2Url + config.familyHealthPayRoyalSundaram, data, { headers: this.authorizedHeader }).pipe(catchError(this.error));
        return res;
    }
    
    proceedtoPayCareHealth(data) {
        this.getUserAuthentication();
        let res = this.httpClient.post(environment.pam2Url + config.familyHealthPayCareHealth, data, { headers: this.authorizedHeader }).pipe(catchError(this.error));
        return res;
    }
    
    sendPolyclinicRequestMail(data) {
        this.getUserAuthentication();
        let res = this.httpClient.post(environment.pam2Url + config.sendPolyclinicRequest, data, { headers: this.authorizedHeader }).pipe(catchError(this.error));
        return res;
    }

    saveSurgicalCare(data) {
        this.getUserAuthentication();
        let res = this.httpClient.post(environment.host + config.saveSurgicalCare, data, { headers: this.authorizedHeader }).pipe(catchError(this.error));
        return res;
    }

    saveCosmeticCare(data) {
        this.getUserAuthentication();
        let res = this.httpClient.post(environment.host + config.saveCosmeticCare, data, { headers: this.authorizedHeader }).pipe(catchError(this.error));
        return res;
    }

    retrieveQuoteList(type, mobile, rmId) {
        const searchType = type === 'Quote Id' ? 'quoteId=' : 'mobile=';
        let res = this.httpClient.get(environment.pam2Url + config.retrieveQuoteList + searchType + mobile + '&rmId=' + rmId, { headers: this.authorizedHeader }).pipe(catchError(this.error));
        return res;
    }
    retrieveQuote(quoteId) {
        let res = this.httpClient.get(environment.pam2Url + config.retrieveQuote + 'quoteId=' + quoteId, { headers: this.authorizedHeader }).pipe(catchError(this.error));
        return res;
    }

    retrieveQuoteListforRequestedQuotes(mobile) {
        let res = this.httpClient.get(environment.pam2Url + config.retrieveQuoteList + 'mobileNumber=' + mobile, { headers: this.authorizedHeader }).pipe(catchError(this.error));
        return res;
    }

    // getLatestRetreiveQuote(mobile) {
    //     let res = this.httpClient.get(environment.pam2Url + config.getLatestRetrieveQuote + mobile, { headers: this.authorizedHeader }).pipe(catchError(this.error));
    //     return res;
    // }

    getLatestRetreiveQuote(mobile) {
        let res = this.httpClient.get(environment.host + config.getLatestRetrieveQuoteUsingNotify + mobile, { headers: this.authorizedHeader }).pipe(catchError(this.error));
        return res;
    }
    
    reditectToMfineApp(data) {       
        const headers= new HttpHeaders()
        .set('content-type', 'application/json')
        .set('secret_key', environment.mfineSecretKey)
        .set('client_id', 'securenow')
        let res = this.httpClient.post(environment.mfineHost+'/api/v1/silent-login', data, { 
            headers: headers }).pipe(catchError(this.error));
        return res;
    }

    mfineSubscribeAPI(data) {       
        const headers= new HttpHeaders()
        .set('content-type', 'application/json')
        .set('secret_key', environment.mfineSecretKey)
        .set('client_id', 'securenow')
        .set('x-parent-org-id', '6163c4c7ced5b99357898122')
        let res = this.httpClient.post(environment.mfineHost+'/api/v1/subscriptions/subscribe', data, { 
            headers: headers }).pipe(catchError(this.error));
        return res;
    }

    getMedPayToken() {
        const body = new HttpParams()
            .set('grant_type', 'client_credentials');

        const headers = new HttpHeaders({
            'Content-Type': 'application/x-www-form-urlencoded',
            'Authorization': `Basic ${btoa(`${environment.medPayClientID}:${environment.medPayclientSecret}`)}`,
        });

        const res = this.httpClient.post(`${environment.medPayAuthUrl}/oauth2/token`, body.toString(),
            { headers }).pipe(catchError(this.error));

        return res;
    };

    loginAndredirectToMeday(requestBody, accessToken) {
        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${accessToken}`,
            'x-api-key': environment.medPayAPIKey
        });

        let res = this.httpClient.post(`${environment.medPayHostUrl}/partner/user/login`, requestBody,
            { headers }).pipe(catchError(this.error));

        return res;
    };

    returningUserQuote(quoteId) {
        let res = this.httpClient.get(environment.pam2Url + config.returningUserQuote  +  quoteId, { headers: this.authorizedHeader }).pipe(catchError(this.error));
        return res;
    }

    sendRetriveSms(data) {
        this.getUserAuthentication();
        let res = this.httpClient.post(environment.pam2Url + config.sendretrieveSMS, data, { headers: this.authorizedHeader }).pipe(catchError(this.error));
        return res;
    }

    sendRetriveEmail(data) {
        this.getUserAuthentication();
        let res = this.httpClient.post(environment.pam2Url + config.sendretrieveEmail, data, { headers: this.authorizedHeader }).pipe(catchError(this.error));
        return res;
    }

    getRmProspects(data) {
        this.getUserAuthentication();
        let res = this.httpClient.post(environment.pam3Url + config.getRMProspects, data, { headers: this.authorizedHeader }).pipe(catchError(this.error));
        return res;
    }

    getRmClients(data) {
        this.getUserAuthentication();
        let res = this.httpClient.post(environment.pam3Url + config.getRMClients, data, { headers: this.authorizedHeader }).pipe(catchError(this.error));
        return res;
    }

    getRMRenewals(data) {
        this.getUserAuthentication();
        let res = this.httpClient.post(environment.pam3Url + config.getRMRenewals, data, { headers: this.authorizedHeader }).pipe(catchError(this.error));
        return res;
    }

    assignToRM(data) {
        this.getUserAuthentication();
        let res = this.httpClient.post(environment.pam3Url + config.assignRM + '?source=' + "mobileApp", data, { headers: this.authorizedHeader }).pipe(catchError(this.error));
        return res;
    }

    getUserData() {
        this.getUserAuthentication();
        let res = this.httpClient.get(environment.host + config.getUserData , { headers: this.authorizedHeader }).pipe(catchError(this.error));
        return res;
    }
    
    getPolyStatus(data) {
        this.getUserAuthentication();
        let res = this.httpClient.post(environment.host + config.getPolyStatus,data, { headers: this.authorizedHeader }).pipe(catchError(this.error));
        return res;  
    }

    getSurgicalStatus(data) {
        this.getUserAuthentication();
        let res = this.httpClient.post(environment.host + config.getSurgicalCareStatus,data, { headers: this.authorizedHeader }).pipe(catchError(this.error));
        return res;  
    }

    getCosmeticStatus(data) {
        this.getUserAuthentication();
        let res = this.httpClient.post(environment.host + config.getCosmeticCareStatus,data, { headers: this.authorizedHeader }).pipe(catchError(this.error));
        return res;  
    }

    getWalletHistory(userID) {
        this.getUserAuthentication();
        let res = this.httpClient.get(environment.host + config.getWalletHistory + userID, { headers: this.authorizedHeader }).pipe(catchError(this.error));
        return res;
    }

    // getClaimHistoryByIntimations(intimation) {
    //     let res = this.httpClient.get(environment.pam2Url + config.getClaimsHistory + intimation).pipe(catchError(this.error));
    //     return res;
    // }

    getClaimHistoryByIntimations(intimation) {
        let res = this.httpClient.get(environment.host + config.getClaimsHistoryUsingNotify + intimation, { headers: this.authorizedHeader }).pipe(catchError(this.error));
        return res;
    }

    // getnoByInsurer(intimation) {
    //     let res = this.httpClient.get(environment.pam2Url + config.noByInsurer + intimation).pipe(catchError(this.error));
    //     return res;
    // }

    getnoByInsurer(intimation) {
        let res = this.httpClient.get(environment.host + config.noByInsurerUsingNotify + intimation, { headers: this.authorizedHeader }).pipe(catchError(this.error));
        return res;
    }

    // getdocuments(intimation) {
    //     let res = this.httpClient.get(environment.pam2Url + config.getdocuments + intimation).pipe(catchError(this.error));
    //     return res;
    // }

    getdocuments(intimation) {
        let res = this.httpClient.get(environment.host + config.getdocumentsUsingNotify + intimation, { headers: this.authorizedHeader }).pipe(catchError(this.error));
        return res;
    }

    getgetamount(intimation) {
        let res = this.httpClient.get(environment.pam2Url + config.getamount + intimation).pipe(catchError(this.error));
        return res;
    }

    // numberByInsurer(intimation) {
    //     let res = this.httpClient.get(environment.pam2Url + config.noByInsurer + intimation).pipe(catchError(this.error));
    //     return res;
    // }

    numberByInsurer(intimation) {
        let res = this.httpClient.get(environment.host + config.noByInsurerUsingNotify + intimation, { headers: this.authorizedHeader }).pipe(catchError(this.error));
        return res;
    }

    redeemWalletPoints(userID, amount) {
        this.getUserAuthentication();
        let res = this.httpClient.post(environment.host + config.redeemWalletPoints + userID, amount, { headers: this.authorizedHeader }).pipe(catchError(this.error));
        return res;  
    }


    referralist(referralData) {
        this.getUserAuthentication();
        let res = this.httpClient.post(environment.host + config.referredDetailslist ,referralData, { headers: this.authorizedHeader }).pipe(catchError(this.error));
        return res;
    }

    // deletereferralist(userID) {
    //     this.getUserAuthentication();
    //     let res = this.httpClient.delete(environment.host + config.deleteReferral + userID, { headers: this.authorizedHeader }).pipe(catchError(this.error));
    //     return res;
    // }

    deletereferralist(id) {
        this.getUserAuthentication();
        let res = this.httpClient.delete(environment.host + config.deleteReferral + id , { headers: this.authorizedHeader }).pipe(catchError(this.error));
        return res;
    }

    

    sendEmails(data) {


        // const authToken = JSON.parse(localStorage.getItem('authToken'));
        // let authToken = this.getUserAuthentication();
        this.getUserAuthentication();
        console.log('testing')
        let res = this.httpClient.post(environment.host + config.sendEmailss,data, { headers: this.authorizedHeader }).pipe(catchError(this.error));
        // console.log('testing1' + authToken)
        return res;  
    }


    error(error: Response | any) {
        return throwError(error);
    }

    getStaticsData(rmId) {
        let res = this.httpClient.get(environment.msUrl + config.agentStaticsData  + rmId, { headers: this.authorizedHeader }).pipe(catchError(this.error));
        return res;
    }

    getDashboardData(rmId) {
        let res = this.httpClient.get(environment.msUrl + config.agentDashboardData  + rmId, { headers: this.authorizedHeader }).pipe(catchError(this.error));
        return res;
    }    
    getAgentComment(leadId) {
        let res = this.httpClient.get(environment.msUrl + config.agentComment  + leadId, { headers: this.authorizedHeader }).pipe(catchError(this.error));
        return res;
    }   
    updateComment(data) {
        let res = this.httpClient.put(environment.msUrl + config.updateAgentComment, data, { headers: this.authorizedHeader }).pipe(catchError(this.error));
        return res;
    }
    getAgentList(supervisorId) {
        this.getUserAuthentication();
        let res = this.httpClient.get(environment.msUrl + config.getAgent  + supervisorId, { headers: this.authorizedHeader }).pipe(catchError(this.error));
        return res;
    } 

    saveClicked(data) {
        this.getUserAuthentication();
        let res = this.httpClient.post(environment.host + config.saveClickEvent, data, { headers: this.authorizedHeader }).pipe(catchError(this.error));
        return res;
    }
        getPamRefarralList(mobileNo) {
        let res = this.httpClient.get(environment.msUrl + config.pamReferralList + "?mobile=" + mobileNo, { headers: this.authorizedHeader }).pipe(catchError(this.error));
        return res;
    }

    savePolyData(data) {
        this.getUserAuthentication();
        let res = this.httpClient.post(environment.host + config.savePolyclinicInMongo, data, { headers: this.authorizedHeader }).pipe(catchError(this.error));
        return res;
    }

    getReferralStatus(id) {
        this.getUserAuthentication();
        let res = this.httpClient.post(environment.pam2Url + config.getSingleReferralStatus + id , { headers: this.authorizedHeader }).pipe(catchError(this.error));
        return res;
    }

    setMobileEmailDetails(data,type) {
        let res = this.httpClient.put(environment.host + config.setMobileEmail+type, data, { headers: this.authorizedHeader }).pipe(catchError(this.error));
        return res;
    }
    sendFirstLoginMail(data) {
        this.getUserAuthentication();
        let res = this.httpClient.post(environment.host + config.sendWelcomeLoginMail, data, { headers: this.authorizedHeader }).pipe(catchError(this.error));
        return res;
    }
    updateWalletForPolicyView(policyId) {
        let res = this.httpClient.put(environment.host + config.walletForEcardView + policyId, { headers: this.authorizedHeader }).pipe(catchError(this.error));
        return res;
    }
    
    getAttendanceTabStatus(userId) {
        //console.log(" inside get status service")
        let res = this.httpClient.get(environment.host + config.attendanceTabCheckStatus + userId, { headers: this.authorizedHeader }).pipe(catchError(this.error));
        return res;
    }

    verifyAuthTokenstatus(authData) {
        this.getUserAuthentication();
        let res = this.httpClient.post(environment.host + config.verifyAuthToken ,authData, { headers: this.authorizedHeader }).pipe(catchError(this.error));
        return res;
    }

    getRetrieveQuoteListUsingNotify(mobileNo) {
        this.getUserAuthentication();
        let res = this.httpClient.get(environment.host + config.retrieveQuoteListUsingNotify + mobileNo, { headers: this.authorizedHeader }).pipe(catchError(this.error));
        return res;
    }
    
    getAllActiveEcards(payload) {
        this.getUserAuthentication();
        let res = this.httpClient.post(environment.host + config.getAllActiveEcards ,payload, { headers: this.authorizedHeader }).pipe(catchError(this.error));
        return res;
    }

    deleteActiveEcards(data) {
        this.getUserAuthentication();
        let res = this.httpClient.put(environment.host + config.deleteActiveEcardsApi ,data, { headers: this.authorizedHeader }).pipe(catchError(this.error));
        return res;
    }

    deletionInProgressActiveEcards(payload) {
        this.getUserAuthentication();
        let res = this.httpClient.post(environment.host + config.deletionInProgressActiveEcardsApi ,payload, { headers: this.authorizedHeader }).pipe(catchError(this.error));
        return res;
    }

    PreviewPremiumApi(targetArray) {
        this.getUserAuthentication();
        let res = this.httpClient.post(environment.host + config.previewProratedPremiumApi ,targetArray, { headers: this.authorizedHeader }).pipe(catchError(this.error));
        return res;
    }

    saveEndoresmentApiForApp(saveEndoPayload) {
        this.getUserAuthentication();
        let res = this.httpClient.post(environment.host + config.saveEndoresementForApp,saveEndoPayload,{ headers: this.authorizedHeader }).pipe(catchError(this.error));
        return res;
    }

    downloadClaimForm(id){
        const headers = new HttpHeaders({ 'Content-Type': 'application/pdf' });
        let res = this.httpClient.get(environment.pam2Url + config.downloadClaimForm+ id).pipe(catchError(this.error));
        return res;
    }
    getAllBatchForThePolicyApi(policyNumber,startDate,endDate) {
        this.getUserAuthentication();
        let res = this.httpClient.get(environment.host + config.getAllBatchesForPolicy +policyNumber+"&startDate="+startDate+"&endDate="+endDate, { headers: this.authorizedHeader }).pipe(catchError(this.error));
        return res;
    }

    getAllEmployeesFromBatch(batchId) {
        this.getUserAuthentication();
        let res = this.httpClient.get(environment.host + config.getAllEmployeeFromBatchApi +batchId,{headers:this.authorizedHeader}).pipe(catchError(this.error));
        return res;
    }

    getBatchDetailsFromBatchIdApi(batchId) {
        this.getUserAuthentication();
        let res = this.httpClient.get(environment.host + config.getBatchDetailsFromBatchId +batchId,{ headers: this.authorizedHeader }).pipe(catchError(this.error));
        return res;
    }

    updateEmployeeEndoApi(employeeToUpdate) {
        this.getUserAuthentication();
        let res = this.httpClient.post(environment.host + config.updateEmployeeEcard , employeeToUpdate , { headers: this.authorizedHeader }).pipe(catchError(this.error));
        return res;
    }

    additionInProgressActiveEcardsApi(cardNumber,endDate) {
        this.getUserAuthentication();
        let res = this.httpClient.get(environment.host + config.additionInProgressActiveEcardsApi + cardNumber +"/"+endDate, { headers: this.authorizedHeader }).pipe(catchError(this.error));
        return res;
    }

    updationProgressActiveEcardsApi(payload) {
        this.getUserAuthentication();
        let res = this.httpClient.post(environment.host + config.updationInProgressActiveEcardsApi ,payload, { headers: this.authorizedHeader }).pipe(catchError(this.error));
        return res;
    }

    saveEmloyeeTempInNotify(data) {
        this.getUserAuthentication();
        let res = this.httpClient.post(environment.host + config.saveEmloyeeTempInNotifyApi ,data, { headers: this.authorizedHeader }).pipe(catchError(this.error));
        return res;
    }

    additionTempInNotify(payload) {
        this.getUserAuthentication();
        let res = this.httpClient.post(environment.host + config.AddtionTempInNotifyApi , payload, { headers: this.authorizedHeader }).pipe(catchError(this.error));
        return res;
    }

    editEmployeeEndoApi(id,editEmployeeData) {
        this.getUserAuthentication();
        let res = this.httpClient.post(environment.host + config.editEmployeeEcardsApi + id,editEmployeeData , { headers: this.authorizedHeader }).pipe(catchError(this.error));
        return res;
    }

    getHoldCdBalance(clientId,insurerId,cdNameId,productId) {
        this.getUserAuthentication();
        let res = this.httpClient.get(environment.pam2Url + config.getHoldCdBalanceApi + clientId +"&insurerId="+insurerId+"&cdNameId="+cdNameId+"&productId="+productId, { headers: this.authorizedHeader }).pipe(catchError(this.error));
        return res;
    }

     getBatchUpdateInProgress(payload) {
        this.getUserAuthentication();
        let res = this.httpClient.post(environment.host + config.batchesUpdateInProgres , payload, { headers: this.authorizedHeader }).pipe(catchError(this.error));
        return res;
    }

    getAllUpdationBatches(payLoad) {
        this.getUserAuthentication();
        let res = this.httpClient.post(environment.host + config.allUpdationBatches,payLoad , { headers: this.authorizedHeader }).pipe(catchError(this.error));
        return res;
    }

    allEmployeesFromBatchWithUpdate(batchId) {
        this.getUserAuthentication();
        let res = this.httpClient.get(environment.host + config.getAllEmployeesFromBatchWithUpdate +batchId,{headers:this.authorizedHeader}).pipe(catchError(this.error));
        return res;
    }

    getAndUpdateFreeGPCStatus(clientId, status){
        this.getUserAuthentication();
        let res = this.httpClient.post(environment.host + config.getAndUpdateFreeGpStatus + clientId + status, { headers: this.authorizedHeader }).pipe(catchError(this.error));
        return res;
    }

    getLinkFromExcelUpload(payload,headers){
        let res = this.httpClient.post("https://securenow.in"+config.getLinkFromExcelUpload ,payload, { headers: headers }).pipe(catchError(this.error));
        return res;
    }

    getParentsData(payload){
        this.getUserAuthentication();
        let res = this.httpClient.post(environment.host + config.getParentsDataApi,payload, { headers: this.authorizedHeader }).pipe(catchError(this.error));
        return res;
    }

    getDownloadEcards(payLoad){
        this.getUserAuthentication();
        let res = this.httpClient.post(environment.host + config.getDownloadEcard, payLoad, { headers: this.authorizedHeader }).pipe(catchError(this.error));
        return res;
    }

    superTopUpLeadCreation(payLoad) {
        this.getUserAuthentication();
        let res = this.httpClient.post(environment.pam2Url + config.superTopUpLeadCreation, payLoad, { headers: this.authorizedHeader }).pipe(catchError(this.error));
        return res;
    }

     corporateHealthCheckUp(userId, planId) {
        let res = this.httpClient.get(environment.host + config.corporateHealthCheckup + userId + "/" + planId, { headers: this.authorizedHeader }).pipe(catchError(this.error));
        return res;
    }

    getUserHealthAssessment(userId){
        this.getUserAuthentication();
        let res = this.httpClient.get(environment.host + config.getUserHealthAssessment + userId, { headers: this.authorizedHeader }).pipe(catchError(this.error));
        return res;
    }

    saveUserHealthAssessment(payload){
        this.getUserAuthentication();
        let res = this.httpClient.post(environment.host + config.saveUserHealthAssessment, payload, { headers: this.authorizedHeader }).pipe(catchError(this.error));
        return res;
    }

    getNotifications(userId){ 
        let res = this.httpClient.get(environment.host + config.getNotifications + userId, { headers: this.authorizedHeader }).pipe(catchError(this.error));
        return res;
    }

    getCountOfNotifications(userId){
        let res = this.httpClient.get(environment.host + config.getCountOfNotifications + userId, { headers: this.authorizedHeader }).pipe(catchError(this.error));
        return res;
    }

    markNotificationAsRead(notificationId){
        let res = this.httpClient.get(environment.host + config.markNotificationAsRead + notificationId, { headers: this.authorizedHeader }).pipe(catchError(this.error));
        return res;
    }
}
